import { Controller } from "@hotwired/stimulus";

// Controls loaded content with a spinner.
//
// By default, the spinner should be visible, and the content should have
// the `opacity-0` class. When the content loads, call the `loaded` event
// to remove the spinner and show the content.
//
// For example:
//
//   <div data-controller="loader" class="relative w-32 h-32 bg-gray-100 flex items-center justify-center" >
//     <%= render "shared/spinner" %>
//     <%= image_tag attachment_thumbnail_path(attachment),
//       data: { loader_target: "content", action: "load->loader#loaded" },
//       class: "opacity-0 relative z-10 border border-gray-300 w-full h-full object-cover" %>
//   </div>
export default class extends Controller {
  static targets = ["spinner", "content"];

  connect() {
    // If the content has already loaded by the time the controller connects
    // (e.g., it was cached or very fast), remove the spinner. Otherwise, the
    // will not be visible (i.e., the event has come and gone).
    if (this.hasContentTarget && this.contentTarget.complete) {
      this.loaded();
    }
  }

  loaded() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.remove();
    }

    if (this.hasContentTarget) {
      this.contentTarget.classList.remove("opacity-0");
    }
  }
}
